import $ from 'jquery'

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */
class Modal {
  constructor() {
    this.init = this.init.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    $(document).on('ready', this.init)
  }
  init() {
    this.$modal = $('.js-modal').first()
    this.$modal.on('click', '.js-modal__close', this.close)
    $(document).on('click', '.js-modal__open', this.open)
  }
  open() {
    this.$modal.addClass('is-open')
  }
  close() {
    this.$modal.removeClass('is-open')
  }
}

const m = new Modal()

export default m



// WEBPACK FOOTER //
// ./scripts/components/Modal.js